import axios from "axios";

const instance = axios.create({
  baseURL: "https://fodrix-backend.vercel.app",
});

instance.interceptors.request.use((req) => {
  if (localStorage.getItem("auth")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("auth")).token
    }`;
  } else if (localStorage.getItem("pauth")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("pauth")).token
    }`;
  }

  return req;
});

export default instance;